import ClientDetailsUseCase from "@domains/features/BasicProfile/useCases/ClientDetails";
import GetBrokerageDetailsUseCase from "@domains/features/BasicProfile/useCases/GetBrokerageSegements";
import NomineeDetailsUseCase from "@domains/features/BasicProfile/useCases/NomineeDetails";
import AdvisorRatingUseCase from "@domains/features/BasicProfile/useCases/AdvisorRatingUseCase";
import DeRegisterdDeviceUseCase from "@domains/features/BasicProfile/useCases/DeRegisterDevice";
import GetRegisterdDeviceDetailsUseCase from "@domains/features/BasicProfile/useCases/getRegisteredDetails";
import RegisterDeviceUseCase from "@domains/features/BasicProfile/useCases/DeviceRegister";
import GetRmDetailsUseCase from "@domains/features/BasicProfile/useCases/GetRmDetailsUseCase";
import GetProfilPicUseCase from "@domains/features/BasicProfile/useCases/GetProfilePic";
import SaveProfilePicUseCase from "@domains/features/BasicProfile/useCases/SaveProfilePic";
import DeleteProfilePicUseCase from "@domains/features/BasicProfile/useCases/DeleteProfilePic";
import DownloadKYCDataUseCase from "@domains/features/BasicProfile/useCases/DownloadKYC";
import GetDefaultExchangeUseCase from "@domains/features/BasicProfile/useCases/GetDefaultExchange";
import WhatsappUseCase from "@domains/features/BasicProfile/useCases/WhatsappDetails";
import GetWealthAdvisorDetailsUseCase from "@domains/features/BasicProfile/useCases/WealthAdvisor";
import mandateCalendarUseCase from "@domains/features/BasicProfile/useCases/MandateCalendar";
import DeleteUpiUseCase from "@domains/features/BasicProfile/useCases/DeleteUpi";
import SaveLeadUseCase from "@domains/features/BasicProfile/useCases/SaveLead";
export default (repositories) => {
    return {
        basicProfile: {
            clientDetails: new ClientDetailsUseCase(repositories.basicProfile),
            getBrokerageSegmentDetails: new GetBrokerageDetailsUseCase(repositories.basicProfile),
            nomineeDetails: new NomineeDetailsUseCase(repositories.basicProfile),
            advisorRating: new AdvisorRatingUseCase(repositories.basicProfile),
            getRegisteredDeviceDetails: new GetRegisterdDeviceDetailsUseCase(repositories.basicProfile),
            deRegisterDeviceDetails: new DeRegisterdDeviceUseCase(repositories.basicProfile),
            registerDeviceDetails: new RegisterDeviceUseCase(repositories.basicProfile),
            getRmDetails: new GetRmDetailsUseCase(repositories.basicProfile),
            GetProfilePic: new GetProfilPicUseCase(repositories.basicProfile),
            saveProfilePic: new SaveProfilePicUseCase(repositories.basicProfile),
            deleteProfilePic: new DeleteProfilePicUseCase(repositories.basicProfile),
            whatsappConsent: new WhatsappUseCase(repositories.basicProfile),
            downloadKYCData: new DownloadKYCDataUseCase(repositories.basicProfile),
            DefaultExchange: new GetDefaultExchangeUseCase(repositories.basicProfile),
            wealthAdvisor: new GetWealthAdvisorDetailsUseCase(repositories.basicProfile),
            saveLead: new SaveLeadUseCase(repositories.basicProfile),
            mandateCalendar: new mandateCalendarUseCase(repositories.basicProfile),
            deleteUpi: new DeleteUpiUseCase(repositories.basicProfile),
        },
    };
};
